// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Yxqrx{margin-top:12px;margin-left:36px;width:calc(100% - 36px);min-width:480px;max-width:calc((100% - 36px)*2/3)}.dbgQe{margin-top:0;margin-left:0;width:auto;min-width:0;max-width:none;display:flex;flex-direction:column;flex:1 1 0}.nIjsB{flex:2 1 0}.a6SpL{flex:1 1 0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"preview": `Yxqrx`,
	"previewInRow": `dbgQe`,
	"previewInRowEmail": `nIjsB`,
	"previewInRowSms": `a6SpL`
};
export default ___CSS_LOADER_EXPORT___;
